/**
 * Which aggregator an order came from. Uplifted 2026-09-15 for `myOrders/orderDetail`. A leaf
 * like `fulfillmentStatus.ts`. The bodies are the apps' HELPER versions, token-identical across
 * platforms (web `helper/myOrderHelpers`; mobile splits them between `saleHelpers` and
 * `myOrderHelpers`).
 *
 * ⚠️ `MyOrderCart` on web ALSO declared local `isSwiggyOrder` / `checkAPISupportOrder` /
 * `isRiderAssigned` with different bodies (the local `checkAPISupportOrder` adds a
 * `saleStatus === Open` test and reads only `sourceInfo.source`; the local `isRiderAssigned`
 * reads the event log, this helper reads `deliveryBy`). Those locals live on in
 * `myOrders/orderDetail` under names that say what they test; these are the helpers.
 */
import { API_SUPPORT_SOURCES, ONLINE, SWIGGY, ZOMATO } from "../../utils/constants/shared";
import { isPosChannel } from "../../models/sale";
import { isSelfDeliveryOrder } from "./rider";

const sourceOf = (o: any) => (o?.onlineSource || o?.sourceInfo?.source || "").toLowerCase();

export const isZomatoOrder = (o: any) => sourceOf(o) === ZOMATO;

export function isSwiggyOrder(o: any) {
  return o?.sourceInfo?.source?.toLowerCase() === SWIGGY;
}

/** An online order from the api / support source, whatever its status. */
export function checkAPISupportOrder(o: any) {
  return o?.channel?.toLowerCase() === ONLINE && API_SUPPORT_SOURCES.includes(sourceOf(o));
}

/**
 * Does Rista's own rider flow (DAAS) apply to this order? A Zomato self-delivery, an api/support
 * order, or a POS order. Identical in both apps' `helper/myOrderHelpers`; moved with the feature
 * gate (Fulfilment CTA, Assign Rider).
 */
export function isDAASOrderSource(orderData: any) {
  return (isZomatoOrder(orderData) &&
    isSelfDeliveryOrder(orderData)) ||
    checkAPISupportOrder(orderData) || //checking api or support order
    isPosChannel(orderData?.channel)
}
